/**
 * RegisterStep2 - Workspace setup
 * Step 2 of 3: Company Name, Workspace Name
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/v2/ui/Button';
import { Input } from '@/components/v2/ui/Input';

interface Props {
  onComplete: (data: { company_name: string; workspace_name: string }) => void;
  initialData: { company_name: string; workspace_name: string };
  isSubmitting: boolean;
}

interface Errors {
  company_name?: string;
  workspace_name?: string;
}

export function RegisterStep2({ onComplete, initialData, isSubmitting }: Props) {
  const { t } = useTranslation();
  const [companyName, setCompanyName] = useState(initialData.company_name);
  const [workspaceName, setWorkspaceName] = useState(initialData.workspace_name);
  const [errors, setErrors] = useState<Errors>({});

  const validate = (): boolean => {
    const newErrors: Errors = {};

    if (!companyName || !companyName.trim()) {
      newErrors.company_name = 'Firmenname ist erforderlich';
    }

    if (!workspaceName || !workspaceName.trim()) {
      newErrors.workspace_name = 'Workspace-Name ist erforderlich';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {
      onComplete({
        company_name: companyName.trim(),
        workspace_name: workspaceName.trim(),
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="register-step2 space-y-4">
      <Input
        label="Firmenname"
        type="text"
        value={companyName}
        onChange={(e) => setCompanyName(e.target.value)}
        error={errors.company_name}
        helperText={t('auth.billingEmailHint')}
        required
        disabled={isSubmitting}
        placeholder="Meine Firma GmbH"
      />

      <Input
        label="Workspace-Name"
        type="text"
        value={workspaceName}
        onChange={(e) => setWorkspaceName(e.target.value)}
        error={errors.workspace_name}
        helperText="Z.B. 'Mein Hauptshop' oder 'Agentur Projekt 1'"
        required
        disabled={isSubmitting}
        placeholder="Mein Workspace"
      />

      <div className="pt-4 space-y-2">
        <Button
          type="submit"
          variant="primary"
          className="w-full"
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          {isSubmitting ? t('auth.creating') : t('auth.completeRegistration')}
        </Button>

        <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
          Du startest mit dem kostenlosen Free-Plan
        </p>
      </div>
    </form>
  );
}
